/**
 * useVolumes Hook
 *
 * Custom React Query hook for fetching volume resources list.
 */

import { useQuery } from '@tanstack/react-query';
import { volumeService } from '../../../api/volume.service';
import type { VolumeListQuery } from '../../../types/volume.types';

/**
 * Hook for fetching volume resources
 * @param tenantId - Tenant ID
 * @param query - Optional query parameters (search, limit)
 */
export const useVolumes = (tenantId: string, query?: VolumeListQuery) => {
  return useQuery({
    queryKey: ['volumes', tenantId, query],
    queryFn: async () => {
      console.log('[useVolumes] Fetching volumes for tenant:', tenantId, 'with query:', query);
      const result = await volumeService.listVolumes(tenantId, query);
      console.log('[useVolumes] Received volume data:', result);
      return result;
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
